<template>
  <HeaderContent title="Maintenance"/>
  <ActionContent ctaText="Maintenance" @action="modal = !modal" @showFilter="modalFilter = !modalFilter"/>
  <MaintenanceStatistics title="Maintenance Statistics" :data="statistics" />
  <MaintenanceForm :modal="modal" @update:modal="modal = $event"/>
  <MaintenanceDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/>
</template>
<script>

import { ref } from 'vue';
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import MaintenanceForm from "./MaintenanceForm.vue";
import MaintenanceStatistics from "@/components/StatisticData.vue";
import MaintenanceDataTable from "@/components/DataTable.vue";
import iconCarCrash from '../../../public/icons/car-crash.svg';
import iconClipboardCheck from '../../../public/icons/clipboard-check.svg';

export default {
  components: {
    HeaderContent,
    ActionContent,
    MaintenanceForm,
    MaintenanceStatistics,
    MaintenanceDataTable,
  },
  setup(){
    const modal = ref(false)
    const showModal = () => {
      modal.value = true
    }
    const data = ref([
      { 
        no: 1,
        service_date: '14/02/2025',
        license_number: 'BK 2021 YR',
        total_km: '50000 km',
        status_maintenance: 'Maintenance Completed',
        driver: 'Adam',
        total_cost: 'Rp. 1.100.000',
        payment_status: 'Lunas',
      },
      {
        no: 2,
        service_date: '15/02/2025',
        license_number: 'BK 2022 YE',
        total_km: '10000 km',
        status_maintenance: 'Maintenance Completed',
        driver: 'Joko',
        total_cost: 'Rp. 700.000',
        payment_status: 'Lunas',
      },
      {
        no: 3,
        service_date: '16/02/2025',
        license_number: 'BK 2023 YF',
        total_km: '20000 km',
        status_maintenance: 'Maintenance Completed',
        driver: 'Udin',
        total_cost: 'Rp. 850.000',
        payment_status: 'Lunas',
      },
      {
        no: 4,
        service_date: '17/03/2025',
        license_number: 'BK 2024 YG',
        total_km: '45000 km',
        status_maintenance: 'Under Maintenance',
        driver: 'Sucipto',
        total_cost: 'Rp. 1.120.000',
        payment_status: 'Pending',
      },
      {
        no: 5,
        service_date: '18/03/2025',
        license_number: 'BK 2025 YH',
        total_km: '47000 km',
        status_maintenance: 'Under Maintenance',
        driver: 'Rahmat',
        total_cost: 'Rp. 1.000.000',
        payment_status: 'Lunas',
      },
    ]);

    const headers = ref([
      {
        key: 'no',
        label: 'No.',
      },
      {
        key: 'service_date',
        label: 'Service Date',
        sortable: true,
      },
      {
        key: 'license_number',
        label: 'License Number',
        sortable: true,
      },
      {
        key: 'total_km',
        label: 'Total KM',
        sortable: true,
      },
      {
        key: 'status_maintenance',
        label: 'Status',
        sortable: true,
      },
      {
        key: 'driver',
        label: 'Driver',
        sortable: true,
      },
      {
        key: 'total_cost',
        label: 'Total Cost',
        sortable: true,
      },
      {
        key: 'payment_status',
        label: 'Payment Status',
        sortable: true,
      },
      {
        key: 'action',
        label: 'Action',
      }
    ])

    const customActions = ref([
      {
          label: 'Update',
          variant: 'primary',
          icon: 'fas fa-check-circle',
          action: (item) => {
            modal.value = true
            console.log('Update action clicked for:', item);
            // Implement your Update logic here
          }
      },
      {
          label: 'Edit',
          variant: 'success',
          icon: 'fas fa-edit',
          action: (item) => {
            console.log('Edit action clicked for:', item);
            // Implement your edit logic here
          }
      },
      {
          label: 'Delete',
          variant: 'danger',
          icon: 'fas fa-trash',
          action: (item) => {
            console.log('Delete action clicked for:', item);
            // Implement your delete logic here
          }
      },
    ]);

    const statistics = ref([
      {
        label: 'Under',
        key: 'Maintenance',
        value: 2,
        color: 'danger',
        icon: iconCarCrash,
      },
      {
        label: 'Maintenance',
        key: 'Completed',
        value: 3,
        color: 'success',
        icon: iconClipboardCheck,
      },
    ])

    return{
      showModal,
      data,
      headers,
      modal,
      customActions,
      statistics,
    }
  }
}
</script>

<style>

</style>